import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { SlideWrapper, SpinWrapper, StyledImg } from './styled';

interface CarouselSlideWithLoadingProps {
  imageUrl: string;
}

// Globally record the urls of the loaded images to avoid duplicate loading
const loadedSet = new Set<string>();
export const CarouselSlide: React.FC<CarouselSlideWithLoadingProps> = ({ imageUrl }) => {
  // Initial loading status: If it has already been loaded, it will no longer load
  const [loading, setLoading] = useState(() => !loadedSet.has(imageUrl));

  useEffect(() => {
    if (loadedSet.has(imageUrl)) {
      setLoading(false);
      return;
    }
    const img = new window.Image();
    img.src = imageUrl;
    const onLoad = () => {
      loadedSet.add(imageUrl);
      setLoading(false);
    };
    const onError = () => setLoading(false);

    img.addEventListener('load', onLoad);
    img.addEventListener('error', onError);
    return () => {
      img.removeEventListener('load', onLoad);
      img.removeEventListener('error', onError);
    };
  }, [imageUrl]);

  return (
    <SlideWrapper style={{ height: loading ? '700px' : '100%' }}>
      {loading && (
        <SpinWrapper>
          <Spin size="large" />
        </SpinWrapper>
      )}
      <StyledImg src={imageUrl} $hide={loading} alt="" />
    </SlideWrapper>
  );
};
